import React, { useState } from 'react';

import Modal from '../../modules/Modal';
import { ContainedButton, OutlinedButton } from '../../modules/Buttons';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { updateSecondaySelectedClips } from '../../../store/sharedStore/sharedStoreSlice';
import styles from './CreateOrSendModal.module.scss';
import DeleteTimelineClipModal from '../../Timeline/DeleteTimelineClipModal';
import { TTimelineSession } from '../../Timeline';
import { CLIP } from '../../../enums';

type TCreateOrSendModal = {
  open: boolean;
  setSession?: React.Dispatch<React.SetStateAction<TTimelineSession[]>>;
  switchModal: () => void;
  switchSendClipModal: () => void;
  switchNewComposerModal: () => void;
  handleEditClip?: (data: CLIP) => void;
  setSkipConfirmationModals: (v: boolean) => void;
  canCreateComposer?: boolean;
};

const CreateOrSendModal: React.FC<TCreateOrSendModal> = ({
  open,
  setSession,
  switchModal,
  handleEditClip,
  switchSendClipModal,
  switchNewComposerModal,
  setSkipConfirmationModals,
  canCreateComposer = true,
}) => {
  // const [showDeleteModal, setShowDeleteModal] = useState(false);
  const { secondarySelectedClips } = useAppSelector((state) => state.sharedStore);
  const dispatch = useAppDispatch();
  const closeModal = () => {
    dispatch(updateSecondaySelectedClips([]));
    switchModal();
  };

  // const switchDeleteModal = () => {
  //   setShowDeleteModal(!showDeleteModal);
  //   setSkipConfirmationModals(true);
  // };

  // const onClipEdit = () => {
  //   switchModal();
  //   handleEditClip && handleEditClip(secondarySelectedClips[0]);
  // };

  // const onSuccessDelete = () => {
  //   switchModal();
  //   setShowDeleteModal(!showDeleteModal);
  // };

  const onSendClip = () => {
    switchModal();
    switchSendClipModal();
    setSkipConfirmationModals(true);
  };

  const onCreateComposer = () => {
    if (!canCreateComposer) return;
    switchModal();
    switchNewComposerModal();
    setSkipConfirmationModals(true);
  };

  return (
    <>
      <Modal open={open} onClose={closeModal}>
        <div className={styles.modal}>
          <div className={styles.modalTitle}>Would you like to send this selected clip to an existing composer or create a new one?</div>
          <div>
            {secondarySelectedClips.length > 0 && (
              <div className={styles.selectedList}>
                <div>Selected clip:</div>
                {secondarySelectedClips.map((c) => (
                  <div key={`${c.id}_selected_clip`}>
                    {' '}
                    {c.topicName}: ({c.clipIndex! + 1}){' '}
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className={styles.actionBtns}>
            <ContainedButton onClick={onCreateComposer} disabled={!canCreateComposer}>
              Create new composer
            </ContainedButton>
            <ContainedButton onClick={onSendClip}>Send to existing composer</ContainedButton>
            {/* {handleEditClip && <ContainedButton onClick={onClipEdit}>Edit clip</ContainedButton>} */}
            {/* <ContainedButton onClick={switchDeleteModal}>Delete clip</ContainedButton> */}
            <OutlinedButton onClick={closeModal}>Cancel</OutlinedButton>
          </div>
          {!canCreateComposer && (
            <div className={styles.permissionHint}>You don’t have permission to create a new online composer from this content.</div>
          )}
        </div>
      </Modal>
      {/* {setSession && <DeleteTimelineClipModal setSession={setSession} open={showDeleteModal} switchModal={onSuccessDelete} />} */}
    </>
  );
};

export default CreateOrSendModal;
